import { ReactComponent as ErrorIconSvg } from "@icons/Error_Icon.svg";
import { ReactComponent as InfoIconSvg } from "@icons/Info_Icon.svg";
import { ReactComponent as CancelIconSvg } from "@icons/cancel.svg";
import { ReactComponent as SuccessIconSvg } from "@icons/Success_Icon.svg";
import classNames from "classnames";
import { Modal } from "../Modal/Modal";
import Button from "../Buttons/Button";
import { ReactNode } from "react";

export interface StatusBody {
  data: {
    image?: ReactNode;
    title: string;
    description?: string;
    cta?: string;
    cancelCta?: string;
  };
  status: "success" | "error" | "info";
  showDismiss?: boolean;
  handleCancel?: () => void;
  handleDismiss?: () => void;
  handleConfirm: () => void;
}

export const StatusModal = ({ data, status, showDismiss, handleCancel, handleDismiss, handleConfirm }: StatusBody) => {
  let Icon;
  switch (status) {
    case "error":
      Icon = ErrorIconSvg;
      break;
    case "success":
      Icon = SuccessIconSvg;
      break;
    case "info":
    default:
      Icon = InfoIconSvg;
  }

  return (
    <Modal width="xs" close={handleDismiss}>
      {!!showDismiss && (
        <div className="flex justify-end items-center pt-6 pr-6">
          <button aria-label="Close modal" type="button" onClick={handleDismiss}>
            <CancelIconSvg />
          </button>
        </div>
      )}
      <div data-testid="status-modal" className={classNames(!!showDismiss ? "px-6 pb-8" : "p-6", "space-y-4")}>
        <div data-testid={`${status}-icon`} className="flex justify-center w-full item-center">
          {data.image ?? <Icon width={50} height={50} />}
        </div>
        <div>
          <h2 className="font-bold text-center">{data.title}</h2>
          <p className="w-full text-center" dangerouslySetInnerHTML={{ __html: data.description ?? "" }}></p>
        </div>
        {data.cta && (
          <div className="space-y-4 pt-4">
            <Button
              data-testid="status-modal-confirm-button"
              text={data.cta}
              onClick={handleConfirm}
              variant={status === "error" ? "secondary" : "default"}
            />

            {handleCancel && (
              <Button variant="text" text={data.cancelCta ?? "Cancel"} data-testid="status-modal-cancel-button" onClick={handleCancel} />
            )}
          </div>
        )}
      </div>
    </Modal>
  );
};
